import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ActionGroupCollapsible.styled';
import { Icon } from '@virtidev/toolbox';
import ActionItem from '../ActionItem/ActionItem';
import AnimateHeight from 'react-animate-height';

const ActionGroupCollapsible = (props) => {
  const [active, setActive] = useState(false);
  const childActions = props.allActions.filter(
    (action) => action.actionGroupId === props.actionGroup.id
  );
  const childActionGroups = props.nestedActionGroups.filter(
    (group) => group.parentId === props.actionGroup.id
  );
  const childrenLength = childActionGroups.length + childActions.length;

  return (
    <>
      <Styled.ActionGroupButton
        disabled={!(childrenLength > 0)}
        active={active}
        onClick={() => setActive(!active)}
        indentLevel={props.indentLevel}
      >
        <Styled.ActionGroupLabelCounterContainer>
          <Styled.ActionGroupLabel>{props.title}</Styled.ActionGroupLabel>
          <Styled.ActionGroupCounter>
            {childrenLength}
          </Styled.ActionGroupCounter>
        </Styled.ActionGroupLabelCounterContainer>
        <Styled.ActionGroupIconContainer active={active}>
          <Icon icon="chevron" color="#ffffff" size="1rem" type="outline" />
        </Styled.ActionGroupIconContainer>
      </Styled.ActionGroupButton>
      <Styled.ActionsContainer active={active}>
        <AnimateHeight
          style={{
            width: '100%',
          }}
          height={active ? 'auto' : 0}
        >
          {childActionGroups.map((actionGroup, index) => (
            <ActionGroupCollapsible
              key={actionGroup.id}
              title={actionGroup.title}
              indentLevel={props.indentLevel + 1}
              actionGroup={actionGroup}
              nestedActionGroups={props.nestedActionGroups}
              allActions={props.allActions}
            />
          ))}
          {childActions.map((action) => (
            <ActionItem
              key={action.id}
              indentLevel={props.indentLevel + 1}
              title={action.title}
              action={action}
            />
          ))}
        </AnimateHeight>
      </Styled.ActionsContainer>
    </>
  );
};

ActionGroupCollapsible.propTypes = {
  title: PropTypes.string.isRequired,
  allActions: PropTypes.array.isRequired,
  nestedActionGroups: PropTypes.array.isRequired,
};

export default ActionGroupCollapsible;
